module.exports = __webpack_public_path__ + "static/media/Assets-03-VirtualSurgery-Exhibition-halftone.ea9cc32f.jpg";